import { CalendarIcon } from "@/Icons/v2/DatePickerIcons/Calendar";
import { useTrans } from "@/translations";

import { useEffect, useState } from "react";

import moment from "moment";

import { toIso } from "../utils";

const DISPLAY_FORMAT = "DD.MM.YYYY";

type Props = {
  labelKey: string;
  value?: Date;
  maxValue: Date;
  onChange: (value: string) => void;
};

export const DateInput: React.FC<Props> = ({
  labelKey,
  value,
  maxValue,
  onChange,
}) => {
  const { t } = useTrans();

  const [text, setText] = useState(
    value ? moment(value).format(DISPLAY_FORMAT) : "",
  );

  useEffect(() => {
    setText(value ? moment(value).format(DISPLAY_FORMAT) : "");
  }, [value]);

  const handleChange = (input: string) => {
    setText(input);

    const parsed = moment(input, DISPLAY_FORMAT, true);
    if (parsed.isValid()) {
      onChange(toIso(parsed.toDate()));
    }
  };

  return (
    <label className="min-w-0 flex-1">
      <div className="font-dm-sans text-grey5 mb-[3px] text-[9.5px] font-bold tracking-[0.06em] uppercase">
        {t(labelKey)}
      </div>
      <div className="relative">
        <input
          type="text"
          value={text}
          placeholder={DISPLAY_FORMAT}
          max={toIso(maxValue)}
          onChange={(e) => handleChange(e.target.value)}
          className="font-dm-sans hover:border-grey3 w-full min-w-0 rounded-md border border-transparent bg-transparent py-[4px] pr-[20px] pl-[6px] text-[13px] font-semibold text-black focus:border-black focus:outline-none"
        />
        <span className="pointer-events-none absolute top-1/2 right-[4px] -translate-y-1/2">
          <CalendarIcon />
        </span>
      </div>
    </label>
  );
};
